import { render, staticRenderFns } from "./VScrollable.vue?vue&type=template&id=cdfe58e8&lang=pug&"
import script from "./VScrollable.vue?vue&type=script&lang=js&"
export * from "./VScrollable.vue?vue&type=script&lang=js&"
import style0 from "./VScrollable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports